import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from 'reactstrap';
import Auth from '../../services/auth';
import './styles.css';

const auth = new Auth();

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
      aboutDropdownOpen: false,
      otherDropdownOpen: false
    };
  }

  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };

  toggleAboutDropdown = () => {
    this.setState({
      aboutDropdownOpen: !this.state.aboutDropdownOpen
    });
  };

  toggleOtherDropdown = () => {
    this.setState({
      otherDropdownOpen: !this.state.otherDropdownOpen
    });
  };

  logout() {
    auth.logout();
  }

  render() {
    return (
      <div>
        <Navbar className="navbar" light expand="md">
          <NavbarBrand href="/">Alfadent</NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse isOpen={!this.state.collapsed} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink tag={Link} to="/homepage">
                  Homepage
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/sluzby">
                  Služby
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/informace">
                  Užitečné informace
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to="/clanky">
                  Články
                </NavLink>
              </NavItem>
              <Dropdown
                nav
                isOpen={this.state.otherDropdownOpen}
                toggle={this.toggleOtherDropdown}
              >
                <DropdownToggle nav caret>
                  Další
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <NavLink tag={Link} to="/kontakt" className="nav-link-dark">
                      Kontakt
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink tag={Link} to="/cenik" className="nav-link-dark">
                      Ceník
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink
                      tag={Link}
                      to="/oklinice"
                      className="nav-link-dark"
                    >
                      O klinice
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink
                      tag={Link}
                      to="/zamestnanci"
                      className="nav-link-dark"
                    >
                      Zaměstnanci
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink
                      tag={Link}
                      to="/reference"
                      className="nav-link-dark"
                    >
                      Reference
                    </NavLink>
                  </DropdownItem>
                  <DropdownItem>
                    <NavLink
                      tag={Link}
                      to="/zakladni-stranky"
                      className="nav-link-dark"
                    >
                      Základní stránky
                    </NavLink>
                  </DropdownItem>
                  {/*              <DropdownItem>
                    <NavLink
                      tag={Link}
                      to="/zakladni-stranky"
                      className="nav-link-dark"
                    >
                      Základní stránky
                    </NavLink>
                  </DropdownItem> */}
                </DropdownMenu>
              </Dropdown>
              <Button color="white" onClick={this.logout}>
                Odhlásit se
              </Button>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js